export const API_BASE_URL = "https://admin.medibear.me" || "http://localhost:8081";
